
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"694","height":"502","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M427.685 501.115c174.61-33.37 261.916-119.92 261.916-259.65C689.6 31.87 749.337.255 427.685.255S0-15.176 0 194.42c0 139.73 142.562 241.962 427.685 306.694z","fill":"#FFD332"}})])
      }
    
      }
    